import { useTranslation } from '@wix/wix-i18n-config';
import { Sound, SoundOff } from '@wix/wix-ui-icons-common';
import React, { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { chatActions } from '../../../common/reducers/chat';
import { selectIsMuted } from '../../../common/selectors/chat';
import { cookie } from '../../../util/cookie';
import { HeaderActionsIcon } from '../HeaderActions/HeaderActionsIcon';
import { headerFullPageDataHooks } from '../HeaderFullPage/HeaderFullPage.dataHooks';

const cookieName = 'isMuted';

export const MuteButton: FC = () => {
  const { t } = useTranslation();
  const isMuted = useSelector(selectIsMuted);
  const tooltipContent = isMuted ? 'header_action_icon_unmute' : 'header_action_icon_mute';
  const dispatch = useDispatch();

  const onToggleMute = useCallback(() => {
    const mute = !isMuted;

    dispatch(chatActions.toggleMute(mute));
    cookie.set(cookieName, mute);
  }, [isMuted, dispatch]);

  return (
    <HeaderActionsIcon
      onClick={onToggleMute}
      dataHook={headerFullPageDataHooks.toggleMute()}
      tooltipContent={t(tooltipContent)}
    >
      {isMuted ? <SoundOff /> : <Sound />}
    </HeaderActionsIcon>
  );
};
